export default "__VITE_ASSET__B3g9aAvO__"